// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cardList--2FrTuF9X .ant-list-items {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .cardList--2FrTuF9X .ant-list-item {\n    padding: 12px;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardList": "cardList--2FrTuF9X"
};
export default ___CSS_LOADER_EXPORT___;
